import { createSelector } from 'reselect';
import { userAllowedRoutesSelector } from '../../../../../shared/store/selectors';


export const searchTextSelector = state => state.pageHelp.searchDocs.searchText;
export const isLoadingSelector = state => state.pageHelp.searchDocs.loading;

export const foundDocumentationSelector = createSelector(
  state => state.pageHelp.searchDocs.foundDocumentation,
  userAllowedRoutesSelector,
  (foundDocumentation, userAllowedPaths) => foundDocumentation.filter(({ pageUrl }) =>
    !pageUrl
      || userAllowedPaths.includes(pageUrl))
);
